export default function (http) {
  return {
    getLanguage(params) {
      return http.post('/MetaImpApi/GetMetaTree', params);
    }
  }
}
